import { create } from 'zustand';

const useCarbonCopyStore = create((set) => ({
  carbon_copy_list: [], // Initial state
  setCarbonCopyList: (value) => set({ carbon_copy_list: value }), // Function to update checked state
}));

export default useCarbonCopyStore;
